<template>
  <!-- вчера было потрачено 60 минут -->
  <BaseModal
    name="statusAndRating"
    width="1280"
    height="auto"
    :clickToClose="false"
    :adaptive="true"
    :scrollable="true"
    classes="!tw-bg-transparent !tw-shadow-none !tw-h-auto"
  >
    <div
      class="tw-bg-white tw-rounded-[25px] tw-pt-[20px] tw-px-[30px] tw-pb-[25px] tw-relative tw-text-forText tw-text-[14px]"
    >
      <button
        type="button"
        class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
        @click="$modal.hide('statusAndRating')"
      ></button>

      <div>
        <div if="!ratingDetails">
          <div
            class="tw-text-[18px] tw-font-semibold tw-text-black tw-leading-[125%]"
          >
            Ваш статус и рейтинг
          </div>
          <div class="tw-text-[11px] tw-text-forText tw-mb-[10px]">
            Рейтинг влияет на приоритет заявок и размер комиссии на отраслевые заказы
          </div>
        </div>
        <!-- <div v-else>
          <div class="tw-text-[20px] tw-text-bold tw-text-black">
            Детализация рейтинга
          </div>
          <div class="tw-text-[15px] tw-text-forText tw-mb-[20px]">
            Текущий рейтинг: {{ rawCompanyRating }}
          </div>
        </div> -->

        <div if="!ratingDetails && fixedCompanyRating_info">
          <div
            class="tw-flex tw-items-center tw-justify-between tw-border-[#E3F0FF] tw-border-solid tw-border-[1px] tw-rounded-[8px] tw-py-[10px] tw-px-[20px] tw-mb-[10px]"
          >
            <div class="tw-flex tw-gap-[15px] tw-items-center">
              <div
                class="tw-flex tw-justify-center tw-items-center tw-rounded-full tw-min-w-[32px] tw-h-[32px]"
                :style="'background:' + fixedCompanyRating_info.color1"
              >
                <img
                  :src="
                    require(`@/assets/icons/status-rating/${fixedCompanyRating_info.icon}`)
                  "
                  class="tw-max-w-[15px] tw-max-h-[15px]"
                />
              </div>
              <div class="tw-flex tw-gap-[8px] tw-items-center">
                <div class="tw-text-[12px]">Статус</div>
                <div
                  class="tw-text-[18px] tw-leading-[125%]"
                  :style="'color:' + fixedCompanyRating_info.color2"
                >
                  {{ dataLang[aboutUser?.company_status_by_rating] }}
                </div>
              </div>
            </div>

            <div class="tw-w-[1px] tw-bg-[#E3F0FF] tw-self-stretch"></div>

            <div class="tw-flex tw-gap-[8px] tw-items-center">
              <div class="tw-text-[12px]">Рейтинг</div>
              <div class="tw-text-[#023F8F] tw-text-[18px] tw-leading-[125%]">
                {{ rawCompanyRating?.replace(".", ",") }} из 100
              </div>
            </div>

            <div class="tw-w-[1px] tw-bg-[#E3F0FF] tw-self-stretch"></div>

            <!-- <div>
              <div>Осталось 10* пунктов до</div>
              <div class="tw-text-[#23B14D] tw-text-[24px]">Профессионал*</div>
            </div> -->

            <div class="tw-flex tw-gap-[8px] tw-items-center">
              <div class="tw-text-[12px]">Баланс</div>
              <div class="tw-text-[#023F8F] tw-text-[18px] tw-leading-[125%]">
                {{ aboutUser?.company_balance?.split(".")?.join(",") }}
                <span class="tw-font-normal">₽</span>
              </div>
            </div>

            <div class="tw-w-[200px]"></div>

            <!-- <div class="tw-w-[1px] tw-bg-[#E3F0FF] tw-self-stretch"></div> -->

            <button
              @click="$modal.show('onAddBalance')"
              class="tw-app-btn-primary !tw-bg-[#023F8F]"
            >
              Пополнить
            </button>
          </div>

          <div
            class="tw-border-[#E3F0FF] tw-border-solid tw-border-[1px] tw-rounded-[8px] tw-pt-[12px] tw-pl-[15px] tw-pr-[25px] tw-pb-[30px] tw-mb-[10px]"
          >
            <div
              class="tw-text-[12px] tw-relative tw-flex tw-items-center tw-justify-between tw-mb-[23px] tw-text-[#111E31]"
            >
              <div
                v-for="(step, index) in [1, 20, 40, 60, 80, 100]"
                :key="index"
                class="tw-absolute tw-transform -tw-translate-x-1/2"
                :style="'left:' + step + '%'"
              >
                {{ step }}
              </div>
            </div>

            <div class="tw-relative">
              <div class="tw-h-[4px] tw-rounded-[4px] tw-bg-[#F5F5F5]"></div>
              <div
                class="tw-absolute tw-top-0 tw-h-[4px] tw-rounded-[4x]"
                :style="
                  'width:' +
                  fixedCompanyRating +
                  '%; background:' +
                  fixedCompanyRating_info.color2
                "
              ></div>
              <div
                class="tw-absolute tw-top-[-13px] tw-ml-[-12px] tw-text-center"
                :style="'left:' + fixedCompanyRating + '%'"
              >
                <div
                  class="tw-flex tw-justify-center tw-items-center tw-rounded-full tw-min-w-[24px] tw-max-w-[24px] tw-h-[24px]"
                  :style="'background:' + fixedCompanyRating_info.color1"
                >
                  <img
                    :src="
                      require(`@/assets/icons/status-rating/${fixedCompanyRating_info.icon}`)
                    "
                    width="10"
                  />
                </div>
                <div
                  class="tw-text-[14px] tw-font-bold"
                  :style="'color:' + fixedCompanyRating_info.color2"
                >
                  {{ fixedCompanyRating }}
                </div>
              </div>
            </div>
          </div>

          <div class="tw-flex tw-gap-[15px] tw-justify-between tw-mb-[10px]">
            <div
              v-for="status in statuses"
              class="hover:tw-border-[#023F8F] tw-flex tw-flex-col tw-justify-between tw-w-full tw-text-center tw-border-[#E3F0FF] tw-border-solid tw-border-[1px] tw-rounded-[8px] tw-py-[12px] tw-px-[10px]"
            >
              <div>
                <div
                  class="tw-inline-flex tw-justify-center tw-items-center tw-p-[4px] tw-rounded-full tw-w-[32px] tw-h-[32px] tw-mb-[8px]"
                  :style="'background:' + status.color1"
                >
                  <img
                    :src="
                      require(`@/assets/icons/status-rating/${status.iconTitle}`)
                    "
                    class="tw-max-w-[16px] tw-max-h-[16px]"
                  />
                </div>
                <div
                  class="tw-text-[18px] tw-font-bold tw-mb-[8px] tw-leading-[125%]"
                  :style="'color:' + status.color2"
                >
                  {{ status.title }}
                </div>
                <div
                  class="tw-text-[12px] tw-inline-flex tw-justify-center tw-py-[4px] tw-rounded-[6px] tw-w-[52px] tw-mb-[15px]"
                  :style="
                    'background:' + status.color1 + '; color:' + status.color2
                  "
                >
                  {{ status.value }}
                </div>
                <div
                  v-for="list in status.list"
                  class="tw-flex tw-items-start tw-gap-[10px] tw-mb-[6px] tw-text-left tw-leading-[125%]"
                >
                  <img
                    :src="
                      require(`@/assets/icons/status-rating/${status.iconList}`)
                    "
                    width="16"
                    class="tw-mt-[2px]"
                  />
                  <div v-html="list"></div>
                </div>
              </div>
              <div
                class="tw-mt-[5px] tw-border-0 tw-border-t-[1px] tw-border-dashed tw-border-[#E3F0FF]"
                :class="{
                  'tw-pt-[5px]': status.minimumCommission,
                  'tw-pt-[10px]': !status.minimumCommission,
                }"
              >
                <div v-if="status.minimumCommission">
                  <div class="tw-text-[14px]">Минимальная комиссия</div>
                  <div class="tw-text-[24px]" :style="'color:' + status.color2">
                    {{ status.minimumCommission }}
                  </div>
                </div>
                <div
                  v-else
                  class="tw-text-[12px] tw-text-[#FF3A20] tw-min-h-[52px] tw-text-left tw-px-[15px] tw-leading-[130%]"
                >
                  Автоблокировка снимается сразу после пополнения баланса выше 0
                </div>
              </div>
            </div>
          </div>

          <div
            class="tw-border-[#E3F0FF] tw-border-solid tw-border-[1px] tw-rounded-[8px] tw-py-[8px] tw-px-[15px] tw-mb-[10px]"
          >
            <div
              class="tw-text-[18px] tw-font-semibold tw-text-black tw-mb-[8px] tw-leading-[125%]"
            >
              Как работает рейтинг
            </div>
            <div class="tw-grid tw-grid-cols-3 tw-gap-[15px]">
              <div v-for="(item, index) in howWork" :key="index">
                <div class="tw-flex tw-gap-[10px] tw-items-start">
                  <div
                    class="tw-flex tw-justify-center tw-items-center tw-rounded-full tw-w-full tw-max-w-[52px] tw-h-[52px]"
                    :style="'background:' + item.bg"
                  >
                    <img
                      :src="
                        require(`@/assets/icons/status-rating/${item.icon}`)
                      "
                      class="tw-max-w-[20px] tw-max-h-[20px]"
                    />
                  </div>
                  <div>
                    <div
                      class="tw-text-forTitle tw-text-[15px] tw-font-semibold tw-leading-[125%]"
                    >
                      {{ item.title }}
                    </div>
                    <div class="tw-text-[12px] tw-leading-[14px]">
                      {{ item.desc }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="ratingDetails" class="tw-min-h-[700px]">
          <!-- таблица рейтинга -->
          <!-- <TableRating /> -->
          <!-- таблица рейтинга -->
        </div>
        <div class="tw-flex tw-justify-between tw-items-center tw-text-[12px]">
          <div class="tw-flex tw-gap-[15px] tw-items-center">
            <div
              class="tw-inline-flex tw-bg-[#F1F3F5] tw-p-[6px] tw-rounded-full"
            >
              <img
                :src="
                  require(`@/assets/icons/status-rating/question-circle.svg`)
                "
                class="tw-max-w-[20px] tw-max-h-[20px]"
              />
            </div>

            <div>
              Есть вопросы?
              <a
                href="mailto:support@sirius.rent"
                class="!tw-text-[#023F8F] hover:tw-underline"
              >
                Свяжитесь с поддержкой
              </a>
            </div>
          </div>
          <!-- <button
            @click="ratingDetails = !ratingDetails"
            class="tw-app-btn-primary !tw-bg-[#023F8F]"
          >
            <span v-if="!ratingDetails"> Детализация рейтинга </span>
            <span v-else> Ваш статус и рейтинг </span>
          </button> -->
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import TableRating from "@/components/TableRating.vue";

export default {
  props: ["aboutUser", "fixedCompanyRating", "rawCompanyRating"],
  components: {
    TableRating,
  },
  data() {
    return {
      ratingDetails: false,
      howWork: [
        {
          icon: "arrow-top.svg",
          bg: "#EDF7F0",
          title: "Рейтинг повышается",
          desc: "За успешные заказы, хорошие оценки, активность и соблюдение правил",
        },
        {
          icon: "arrow-bottom.svg",
          bg: "#FFC8C8",
          title: "Рейтинг понижается",
          desc: "За отказы, отмены, жалобы, просрочки и нарушения правил",
        },
        {
          icon: "info.svg",
          bg: "#EEF4FA",
          title: "Обновление рейтинга",
          desc: "Рейтинг пересчитывается ежедневно на основе активности и качества работы",
        },
      ],
      statuses: [
        {
          color1: "#FFC8C8",
          color2: "#FF3A20",
          title: "Блокировка",
          iconTitle: "blocked.svg",
          list: ["Заявки недоступны"],
          iconList: "blocked2.svg",
          value: 0,
        },
        {
          color1: "#FFF5D9",
          color2: "#BF8E00",
          title: "Ограниченный",
          iconTitle: "limited.svg",
          list: [
            "Ограниченный поток заявок",
            "Заявки от операторов аренды - 4-й приоритет",
            "Без заявок от агрегаторов",
          ],
          iconList: "limited2.svg",
          value: "1-39",
          minimumCommission: "30%",
        },
        {
          color1: "#E3F0FF",
          color2: "#023F8F",
          title: "Базовый",
          iconTitle: "base.svg",
          list: [
            "Базовый поток заявок",
            "Заявки от операторов аренды - 3-й приоритет",
            "Заявки от агрегаторов -<br> 3-й приоритет",
          ],
          iconList: "base2.svg",
          value: "40-59",
          minimumCommission: "23%",
        },
        {
          color1: "#EDF7F0",
          color2: "#23B14D",
          title: "Профессионал",
          iconTitle: "professional.svg",
          list: [
            "Основной поток заявок",
            "Заявки от операторов аренды 2-й приоритет",
            "Заявки от агрегаторов -<br> 2-й приоритет",
          ],
          iconList: "professional2.svg",
          value: "60-84",
          minimumCommission: "22%",
        },
        {
          color1: "#F2E3FF",
          color2: "#8000FF",
          title: "Эксперт",
          iconTitle: "expert.svg",
          list: [
            "Максимальный поток заявок ",
            "Заявки от операторов аренды - 1-й приоритет",
            "Заявки от агрегаторов -<br> 1-й приоритет",
          ],
          iconList: "expert2.svg",
          value: "85-100",
          minimumCommission: "20%",
        },
      ],
    };
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    fixedCompanyRating_info() {
      if (this.fixedCompanyRating == 0) {
        return {
          color1: "#FFC8C8",
          color2: "#FF3A20",
          icon: "blocked.svg",
        };
      }
      if (this.fixedCompanyRating >= 1 && this.fixedCompanyRating <= 39) {
        return {
          color1: "#FFF5D9",
          color2: "#BF8E00",
          icon: "limited.svg",
        };
      }
      if (this.fixedCompanyRating >= 40 && this.fixedCompanyRating <= 59) {
        return {
          color1: "#E3F0FF",
          color2: "#023F8F",
          icon: "base.svg",
        };
      }
      if (this.fixedCompanyRating >= 60 && this.fixedCompanyRating <= 84) {
        return {
          color1: "#EDF7F0",
          color2: "#23B14D",
          icon: "professional.svg",
        };
      }
      if (this.fixedCompanyRating >= 85) {
        return {
          color1: "#F2E3FF",
          color2: "#8000FF",
          icon: "expert.svg",
        };
      }
      return null;
    },
  },
};
</script>

<style lang="scss">
.table-type-1 {
  table,
  th,
  td {
    border: 1px solid #e3f0ff;
    padding: 10px 30px;
  }
}
</style>
